import { Loader } from "@atoms";

export const MapiqMapLoading = () => {
  return (
    <div className="flex size-full items-center justify-center">
      <Loader />
    </div>
  );
};
